import { Injectable } from '@angular/core'
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable, throwError, BehaviorSubject } from 'rxjs'
import { catchError, switchMap, filter, take } from 'rxjs/operators'
import { AuthService } from './authService.service'

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip interceptor for login, refresh-token and anonymous review endpoints
    if (
      request.url.includes('login') ||
      request.url.includes('refresh-token') ||
      request.url.includes('SubmitReview') ||
      request.url.includes('getJobRequest') ||
      request.url.includes('getUserInfo')
    ) {
      return next.handle(request)
    }

    const accessToken = this.authService.getAccessToken()

    if (accessToken && accessToken !== 'null') {
      request = this.addToken(request, accessToken)
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(request, next)
        } else {
          return throwError(error)
        }
      })
    )
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    return this.authService.refreshToken().pipe(
      switchMap((accessToken: string) => {
        console.log(
          'Token refreshed successfully. Retrying original request...'
        )
        return next.handle(this.addToken(request, accessToken))
      }),
      catchError((err) => {
        // If refresh fails, log out the user
        this.authService.logout()
        return throwError(err)
      })
    )
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
}
